import i18n from 'i18n'
import * as React from "react"
import { SelectSeeker } from "ui-seeker/core"


const OPTIONS = [
    { label: 'Competition', value: 'competition' },
    { label: 'Parity', value: 'parity' },
]

const ST_KEY = { 'competition': 'common:filters.alertCompetition', 'parity': 'common:filters.alertParity' }

export default function SelectSectionType({ ...props }) {

    const myProps = {
        options: OPTIONS,
        formatOptionLabel: opt => i18n.t(ST_KEY[opt?.value] || '', { defaultValue: opt?.label }),
        placeholder: i18n.t('admin:scheduler.allSectionTypes'),
        isClearable: true, isMulti: true,
        icon: { icon: 'list' },
        ...props
    }

    return <SelectSeeker {...myProps} />
}